module.exports = __webpack_public_path__ + "img/userbg.a4926a8b.svg";